import { useEffect } from 'react';

const GetTheMobileApp = (props) => {
  useEffect(() => {
    const userAgent = navigator.userAgent;

    if (
      (/iPad|iPhone|iPod|Mac|Macintosh/.test(userAgent) && !window.MSStream) ||
      (userAgent.includes('Mac') && 'ontouchend' in document)
    ) {
      window.location.href = 'https://apps.apple.com/us/app/playaz4playaz/id1550239863';
    } else if (/android/i.test(userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.playaz4playaz';
    } else {
      window.location.href =
        'https://qrfy.io/p/MFm43ofcnI?utm_source=qrcode&utm_medium=app&utm_campaign=22988999';
    }
  }, []);
};

export default GetTheMobileApp;
